import axiosAuth from '../config/axios';

export function soportaPush() {
  return 'serviceWorker' in navigator && 'PushManager' in window;
}

// El navegador exige la llave del servidor como Uint8Array, no como texto.
function base64UrlAUint8Array(base64Url) {
  const padding = '='.repeat((4 - (base64Url.length % 4)) % 4);
  const base64 = (base64Url + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export async function suscripcionActual() {
  if (!soportaPush()) return null;
  const registro = await navigator.serviceWorker.ready;
  return registro.pushManager.getSubscription();
}

// Pide permiso al usuario (si hace falta), suscribe este navegador y guarda
// la suscripción en el backend, asociada al usuario autenticado.
export async function activarPush() {
  if (!soportaPush()) throw new Error('Este navegador no soporta notificaciones push');

  if (Notification.permission === 'denied') {
    throw new Error('Las notificaciones están bloqueadas para este sitio en la configuración del navegador');
  }
  const permiso = await Notification.requestPermission();
  if (permiso !== 'granted') throw new Error('Debes permitir las notificaciones para activarlas');

  const { data } = await axiosAuth.get('/api/push/clave-publica');
  const clavePublica = data?.data?.clavePublica;
  if (!clavePublica) throw new Error('El servidor no tiene las notificaciones push configuradas todavía');

  const registro = await navigator.serviceWorker.ready;
  let suscripcion = await registro.pushManager.getSubscription();
  if (!suscripcion) {
    suscripcion = await registro.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: base64UrlAUint8Array(clavePublica),
    });
  }

  await axiosAuth.post('/api/push/suscribir', { suscripcion: suscripcion.toJSON() });
  return suscripcion;
}

export async function desactivarPush() {
  const suscripcion = await suscripcionActual();
  if (!suscripcion) return;
  await axiosAuth.post('/api/push/desuscribir', { endpoint: suscripcion.endpoint });
  await suscripcion.unsubscribe();
}

export async function enviarPushDePrueba() {
  const { data } = await axiosAuth.post('/api/push/prueba');
  return data.data;
}
